import { type HttpErrorResponse } from '@angular/common/http';
import { type ActionPoint } from '@api/devices';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { type ChildRelationDevices, type DeviceAttribute, type DeviceData, type DeviceIncidentRule, type DeviceModel, type NormalizedDeviceData } from '../models';

export const DevicesActions = createActionGroup({
  events: {
    'Add New Device': props<{ locationId: string; newDeviceData: Partial<DeviceData>; }>(),
    'Add New Device Error': emptyProps(),
    'Add New Device Success': props<{ newDevice: DeviceData; }>(),
    'All Client Devices Loaded': props<{ devices: DeviceData[]; }>(),
    'Create Device Incident Rule Success': props<{ rule: DeviceIncidentRule; }>(),
    'Delete Device': props<{ device: NormalizedDeviceData | DeviceData; }>(),
    'Delete Device Error': props<{ error: HttpErrorResponse; }>(),
    'Delete Device Incident Rule Success': props<{ deviceId: string; incidentRuleId: string; }>(),
    'Device Data Successfully Updated': props<{
      device: DeviceData & { childRelations?: ChildRelationDevices[]; };
      oldData: Partial<DeviceData>;
    }>(),
    'Drop Device': props<{ deviceId: string; }>(),
    'Load All Client Devices': emptyProps(),
    'Load Device Collection By Space Id': props<{ locationId: string; roomId: string; withRules?: boolean }>(),
    'Load Device Collection By Space Id Success': props<{ devices: DeviceData[]; }>(),
    'Load Device Collections': emptyProps(),
    'Load Device Collections Success': props<{
      actionPoints: ActionPoint[];
      attributes: DeviceAttribute[];
      models: DeviceModel[];
    }>(),
    'Load Device Details': props<{ deviceId: string; locationId: string; }>(),
    'Load Device Details Failure': props<{ error: HttpErrorResponse; }>(),
    'Load Device Details Success': props<{ deviceItem: DeviceData & { childRelations?: ChildRelationDevices[]; }; }>(),
    'Load Devices Error': props<{ error: HttpErrorResponse; }>(),
    'Reset Device Entity': emptyProps(),
    'Update Device': props<{ device: DeviceData; }>(),
    'Update Device Data': props<{ data: Partial<DeviceData>; deviceId: string; locationId: string; }>(),
    'Update Device Data Error': emptyProps(),
    'Update Device Incident Rule': props<{
      body: Partial<DeviceIncidentRule>;
      deviceId: string;
      incidentRuleId: string;
      locationId: string;
    }>(),
    'Update Device Incident Rule Success': props<{ rule: DeviceIncidentRule; }>(),
  },
  source: 'Devices',
});
